// extracted by mini-css-extract-plugin
export default {"grid":"Concerts_grid__cncUm"};